// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bc282b91","239":"b31f9ffd","453":"c66c311e","455":"11aa8f08"}[chunkId] + ".chunk.js";
};